import React from 'react';

import { cn } from 'components/lib/utils';
import { Card } from 'components/ui/card';

import { ProjectItem } from '../../types';
import { getProjectIcon, getProjectIconBgColor, getProjectTypeLabel } from '../../utils';

import { CardContentSection } from './CardContentSection';
import { CardDropdownMenu } from './CardDropdownMenu';
import { CardImageSection } from './CardImageSection';

interface ProjectCardProps {
    item: ProjectItem;
    onClick: () => void;
    onStarClick?: (item: ProjectItem) => void;
    isStarred?: boolean;
    onUploadClick?: (item: ProjectItem) => void;
    onRemoveImage?: (item: ProjectItem) => void;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({
    item,
    onClick,
    onStarClick,
    isStarred = false,
    onUploadClick,
    onRemoveImage
}) => {
    const typeLabel = getProjectTypeLabel(item.type, item.subType, item.category, item.isParkingDomain);
    const icon = getProjectIcon(item.type, item.subType, item.category, item.isParkingDomain);
    const iconBgColor = getProjectIconBgColor(item.type, item.subType, item.category, item.isParkingDomain);
    const hasImage = Boolean(item.thumbnailImageUrl);


    const handleUploadClick = () => onUploadClick?.(item);
    const handleRemoveImageClick = () => onRemoveImage?.(item);

    return (
        <Card
            className={cn(
                'group relative overflow-hidden cursor-pointer transition-all duration-200',
                'hover:shadow-lg hover:shadow-base-shadow/10',
                'border-base-border bg-base-card hover:bg-base-muted/50',
                'w-full flex flex-col'
            )}
            onClick={onClick}
        >
            <CardDropdownMenu
                hasImage={hasImage}
                onUploadClick={handleUploadClick}
                onRemoveClick={handleRemoveImageClick}
            />

            <CardImageSection
                hasImage={hasImage}
                thumbnailImageUrl={item.thumbnailImageUrl}
                name={item.name}
                icon={icon}
                iconBgColor={iconBgColor}
            />

            <CardContentSection
                item={item}
                typeLabel={typeLabel}
                icon={icon}
                iconBgColor={iconBgColor}
                onStarClick={onStarClick}
                isStarred={isStarred}
            />
        </Card>
    );
};